import { render, staticRenderFns } from "./Instructors.vue?vue&type=template&id=55ec1e82&scoped=true&lang=pug"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"
import style0 from "./Instructors.vue?vue&type=style&index=0&id=55ec1e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ec1e82",
  null
  
)

export default component.exports